module.exports = __webpack_public_path__ + "static/media/nyt.8486a6f8.png";